<div>
  <h3>{{ note.content }}</h3>
  <span class="button is-small is-info" (click)='addHeartToNote(note.hearts)'>
    Heart <i class="fa fa-heart"></i>
  </span>
  <span class="button is-small is-danger" (click)='deleteNote(note?.id)'>Delete</span>
  <p>This note has been hearted {{ note.hearts || 0 }} times.</p>
</div>



// WEBPACK FOOTER //
// ./src/app/notes/note-detail/note-detail.component.html